package com.essntl.uikit.components.chat.message

import com.essntl.uikit.components.chat.message.MessageReact.*

enum class MessageReact {
    Like, Heart, TearsOfJoy, Hushed, SadRelieved, FoldedHands, RaisingHands;

    val getEmojiString: String
        get() = when (this) {
            Like -> "\uD83D\uDC4D"
            Heart -> "\uD83E\uDE77"
            TearsOfJoy -> "\uD83D\uDE02"
            Hushed -> "\uD83D\uDE2E"
            SadRelieved -> "\uD83D\uDE25"
            FoldedHands -> "\uD83D\uDE4F"
            RaisingHands -> "\uD83D\uDE4C"
        }
}

fun getReact(emoji: String?): MessageReact? =
    when (emoji) {
        "\uD83D\uDC4D" -> Like
        "\uD83E\uDE77", "❤\uFE0F" -> Heart
        "\uD83D\uDE02" -> TearsOfJoy
        "\uD83D\uDE2E" -> Hushed
        "\uD83D\uDE25" -> SadRelieved
        "\uD83D\uDE4F" -> FoldedHands
        "\uD83D\uDE4C" -> RaisingHands
        else -> null
    }